import React from "react";
import EmployeeProfileTabHeader from "./EmployeeProfileTabHeader";
import EmployeeProfileSectionCard from "./EmployeeProfileSectionCard";
import EmployeeProfileEmptyState from "./EmployeeProfileEmptyState";
import EmployeeProfileInfoBanner from "./EmployeeProfileInfoBanner";
import EmployeeProfileNoteEntry from "./EmployeeProfileNoteEntry";
import EmployeeProfileNoteInputEntry from "./EmployeeProfileNoteInputEntry";
import AddIcon from "@mui/icons-material/Add";
import NotesIcon from "@mui/icons-material/Notes";

function EmployeeProfileNotesTab(props) {
  const [showInput, setShowInput] = React.useState(false);

  const hasNotes = props.selectedTeamMemberData?.logbook_employee_entries?.length > 0;

  return (
    <div className="max-w-5xl mx-auto">
      {/* Header */}
      <EmployeeProfileTabHeader
        icon={NotesIcon}
        title="Employee Notes"
        subtitle="Track important information and observations"
      />

      <EmployeeProfileInfoBanner>
        Manager-only visibility: employees cannot view these notes.
      </EmployeeProfileInfoBanner>

      {/* Notes Container */}
      {hasNotes || showInput ? (
        <EmployeeProfileSectionCard bodyClassName="">
          {/* Notes List */}
          {hasNotes && (
            <div className="divide-y divide-gray-100">
              {props.selectedTeamMemberData?.logbook_employee_entries?.map((entry, index) => (
                <div key={index} className="p-6">
                  <EmployeeProfileNoteEntry
                    entry={entry}
                    delete_logbook_employee_entry={props.delete_logbook_employee_entry}
                    stm_id={props.stm_id}
                    showInput={showInput}
                    setShowInput={setShowInput}
                    get_file_upload={props.get_file_upload}
                  />
                </div>
              ))}
            </div>
          )}

          {/* Input Section */}
          {showInput && (
            <div className={`p-6 ${hasNotes ? 'border-t border-gray-200 bg-gray-50' : ''}`}>
              <EmployeeProfileNoteInputEntry
                post_logbook_employee_entry={props.post_logbook_employee_entry}
                stm_id={props.stm_id}
                showInput={showInput}
                setShowInput={setShowInput}
                homeCompany={props.homeCompany}
              />
            </div>
          )}

          {/* Add Note Button */}
          {!showInput && (
            <div className="p-6 border-t border-gray-200 bg-gray-50">
              <button
                onClick={() => setShowInput(true)}
                className="w-full flex items-center justify-center space-x-2 text-violet-600 hover:text-violet-700 py-3 rounded-lg border-2 border-dashed border-violet-300 hover:border-violet-400 transition-colors"
              >
                <AddIcon style={{ fontSize: "18px" }} />
                <span className="font-medium">Add Note</span>
              </button>
            </div>
          )}
        </EmployeeProfileSectionCard>
      ) : (
        <EmployeeProfileSectionCard bodyClassName="">
          <EmployeeProfileEmptyState
            icon={NotesIcon}
            title="No notes yet"
            description="Add notes to track important information about this employee. Only managers can view these notes."
            action={
              <button
                onClick={() => setShowInput(true)}
                className="inline-flex items-center gap-1.5 bg-violet-600 hover:bg-violet-700 text-white px-3 py-1.5 rounded-lg text-sm font-medium transition-colors"
              >
                <AddIcon style={{ fontSize: "16px" }} />
                <span>Add First Note</span>
              </button>
            }
          />
        </EmployeeProfileSectionCard>
      )}
    </div>
  );
}

export default EmployeeProfileNotesTab;
